import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../../../config";
import { Modal, ModalBody, ModalHeader } from "reactstrap";


const PhysiologyReport = ({selectedFormId,data,selectedClientDetails}) => {
  const initialState = {
    clientName: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    typeA: false,
    typeT: false,
    session: "",
    date: "",
    practitionerName: "",
    email: "",
    overbreathing: "",
    baselinePetCo2: "",
    symptoms: "",
    recovery: "",
    recoveryReason: "",
    petco2Return: "",
    assist: "",
    assistHow: "",
    trapped: "",
    clientExplanation: "",
    symptomsChange: "",
    otherTimes: "",
    observedRange: "",
    otherSymptoms: "",
    triggers: "",
    triggersExplanation: "",
    petco2ReturnBaseline: "",
    petco2ReturnTime: "",
    trapped2: "",
    recoverOwn: "",
    recoverFactors: "",
    recoverAssistHow: "",
    strategies: "",
    symptomsChangeEnd: "",
    petco2EndRange: "",
    muscleGroup1: "",
    muscleGroup1Range: "",
    muscleGroup2: "",
    muscleGroup2Range: "",
    chestBreathing: "",
    accessoryMuscles: "",
    chestBreathingTriggers: "",
    chestBreathingExplanation: "",
    chestBreathingLike: "",
    diaphragm: "",
    preferChest: false,
    preferDiaphragm: false,
    preferenceReason: "",
    dysponesis: "",
    unrelatedMuscles: "",
    unrelatedTriggers: "",
    dysponesisChange: "",
    posture: "",
    postureHow: "",
    emotionInfluence: "",
    correlation: "",
    initialHRV: "",
    sessionHRV: "",
    endingHRV: "",
    initialSpO2: "",
    sessionSpO2: "",
    endingSpO2: "",
    overallCorrelation: "",
  };
    const { t } = useTranslation();
  const [form, setForm] = useState(data?data:initialState);
  const handleChange = (e) => {
    const { name, type, value, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  // handles radio buttons and grouped checkboxes logic
  const handleCheckbox = (group, val) => {
    setForm((prev) => ({
      ...prev,
      [group]: val,
    }));
  };

 const [successModal, setsuccessModal] = useState(false);
   const successToggleModal = () => setsuccessModal(!successModal);
   const [loading, setLoading] = useState(false);
   const handleSubmit = (e) => {
     e.preventDefault();
 
     const userId = localStorage.getItem("user_id");
     const selectedClient = localStorage.getItem("selectedClient");
     const accessToken = localStorage.getItem("accessToken");
 
     const client_id = selectedClient === "null" ? userId : selectedClient;
 
     // Start loader
     setLoading(true);
 
     // Prepare payload (no need to stringify form_data here)
     const payload = {
       client_id: client_id,
       form_id: selectedFormId, // Ensure this variable is defined
       form_data: JSON.stringify(form),
       session_id:  localStorage.getItem("selectedSession") || null,
     };
 
     console.log("📤 Sending form payload test:", payload);
 
     fetch(API_URL + "/forms/trainer/form-submit", {
       method: "POST",
       headers: {
         "Content-Type": "application/json",
         "x-access-token": accessToken,
       },
       body: JSON.stringify(payload),
     })
       .then((res) => res.json())
       .then((resp) => {
         console.log("✅ Response:", resp);
         if (resp.status) {
           successToggleModal();
           setFormData(initialState);
         } else {
           console.error("❌ Upload failed:", resp.message);
           console.log("Upload failed: " + resp.message);
         }
       })
       .catch((err) => {
         console.error("⚠️ Error submitting form:", err);
         console.log("Something went wrong while submitting the form.");
       })
       .finally(() => {
         setLoading(false);
       });
   };

  return (
    <form
      onSubmit={handleSubmit}
      style={{
        fontFamily: "Arial, sans-serif",
        maxWidth: "1200px",
        margin: "0 auto",
        padding: !data?"20px":"10px",
      border: !data && "1px solid #ccc",
        marginTop: "20px",
      }}
    >
      <h1
        style={{
          color: "#0066cc",
          textAlign: "center",
          fontSize: "24px",
          marginBottom: "20px",
        }}
      >
        PHYSIOLOGY REPORT
      </h1>

      <div style={{ display: "flex", gap: "20px", marginBottom: "10px" }}>
        <div>
          <label style={{ marginRight: "10px" }}>Client Name:</label>
          <input
            type="text"
            name="clientName"
            disabled={Boolean(selectedClientDetails)}
            value={form.clientName}
            onChange={handleChange}
            style={inputStyle("300px")}
          />
        </div>
        <div>
          <label style={{ marginRight: "10px" }}>Type:</label>
          <input
            type="checkbox"
            id="typeA"
            name="typeA"
            checked={form.typeA}
            onChange={handleChange}
          />
          <label htmlFor="typeA" style={{ marginRight: "5px" }}>A</label>
          <input
            type="checkbox"
            id="typeT"
            name="typeT"
            checked={form.typeT}
            onChange={handleChange}
          />
          <label htmlFor="typeT" style={{ marginRight: "15px" }}>T</label>
          <label style={{ marginRight: "5px" }}>Session #</label>
          <input
            type="text"
            name="session"
            value={form.session}
            onChange={handleChange}
            style={inputStyle("40px", true)}
          />
          <label style={{ marginRight: "5px" }}>Date:</label>
          <input
            type="text"
            name="date"
            value={form.date}
            onChange={handleChange}
            style={inputStyle("150px")}
          />
        </div>
      </div>

      <div style={{ marginBottom: "15px" }}>
        <label style={{ marginRight: "10px" }}>Practitioner Name:</label>
        <input
          type="text"
          name="practitionerName"
          value={form.practitionerName}
          onChange={handleChange}
          style={inputStyle("300px", false, "15px")}
        />
        <label style={{ marginRight: "5px" }}>Email:</label>
        <input
          type="text"
          name="email"
          value={form.email}
          onChange={handleChange}
          style={inputStyle("300px")}
        />
      </div>

      <SectionHeader text="CAPNOGRAPHY (PetCO₂)" />

      <div style={{ marginBottom: "10px" }}>
        <strong style={{ marginRight: "10px" }}>
          Was overbreathing (below 35 mmHg) present at the start of the session?
        </strong>
        <input
          type="checkbox"
          id="overbreathingYes"
          name="overbreathing"
          checked={form.overbreathing === "yes"}
          onChange={() => handleCheckbox("overbreathing", "yes")}
        />
        <label htmlFor="overbreathingYes" style={{ marginRight: "10px" }}>Yes</label>
        <input
          type="checkbox"
          id="overbreathingNo"
          name="overbreathing"
          checked={form.overbreathing === "no"}
          onChange={() => handleCheckbox("overbreathing", "no")}
        />
        <label htmlFor="overbreathingNo">No</label>
      </div>

      <InputRow
        label="What were the initial baseline PetCO₂ values (first two minutes)?"
        name="baselinePetCo2"
        value={form.baselinePetCo2}
        onChange={handleChange}
        width="500px"
      />

      <InputRow
        label="What symptoms/deficits were reported, if any?"
        name="symptoms"
        value={form.symptoms}
        onChange={handleChange}
        width="600px"
      />

      <div style={{ marginBottom: "10px", display: "flex", alignItems: "flex-end" }}>
        <label style={{ marginRight: "10px" }}>
          If so, did recovery take place on its own within a few minutes?
        </label>
        <input
          type="checkbox"
          id="recoveryYes"
          name="recovery"
          checked={form.recovery === "yes"}
          onChange={() => handleCheckbox("recovery", "yes")}
        />
        <label htmlFor="recoveryYes" style={{ marginRight: "10px" }}>Yes</label>
        <input
          type="checkbox"
          id="recoveryNo"
          name="recovery"
          checked={form.recovery === "no"}
          onChange={() => handleCheckbox("recovery", "no")}
        />
        <label htmlFor="recoveryNo" style={{ marginRight: "10px" }}>No</label>
        <label style={{ marginRight: "5px" }}>Why?</label>
        <input
          type="text"
          name="recoveryReason"
          value={form.recoveryReason}
          onChange={handleChange}
          style={inputStyle("340px")}
        />
      </div>

      <InputRow
        label="If not, when did PetCO₂ levels return to normal, and why?"
        name="petco2Return"
        value={form.petco2Return}
        onChange={handleChange}
        width="500px"
      />

      <div style={{ marginBottom: "10px", display: "flex", alignItems: "flex-end" }}>
        <label style={{ marginRight: "10px" }}>
          Did you assist in this process?
        </label>
        <input
          type="checkbox"
          id="assistYes"
          name="assist"
          checked={form.assist === "yes"}
          onChange={() => handleCheckbox("assist", "yes")}
        />
        <label htmlFor="assistYes" style={{ marginRight: "10px" }}>Yes</label>
        <input
          type="checkbox"
          id="assistNo"
          name="assist"
          checked={form.assist === "no"}
          onChange={() => handleCheckbox("assist", "no")}
        />
        <label htmlFor="assistNo" style={{ marginRight: "10px" }}>No</label>
        <label>How did you assist?</label>
        <input
          type="text"
          name="assistHow"
          value={form.assistHow}
          onChange={handleChange}
          style={inputStyle("480px")}
        />
      </div>

      <CheckboxRow
        label="Was your client trapped in overbreathing?"
        name="trapped"
        value={form.trapped}
        onChange={handleCheckbox}
      />
      <InputRow
        label="What was your client's explanation for the associated symptoms?"
        name="clientExplanation"
        value={form.clientExplanation}
        onChange={handleChange}
        width="480px"
      />

      <InputRow
        label="How did the symptoms/deficits change as breathing improved?"
        name="symptomsChange"
        value={form.symptomsChange}
        onChange={handleChange}
        width="480px"
      />

      <CheckboxRow
        label="Did overbreathing occur at other times during the interview?"
        name="otherTimes"
        value={form.otherTimes}
        onChange={handleCheckbox}
      />

      <InputRow
        label="What was the range of the PetCO₂ values you observed?"
        name="observedRange"
        value={form.observedRange}
        onChange={handleChange}
        width="520px"
      />
      <InputRow
        label="What symptoms/deficits were reported?"
        name="otherSymptoms"
        value={form.otherSymptoms}
        onChange={handleChange}
        width="550px"
      />
      <InputRow
        label="What were the triggers?"
        name="triggers"
        value={form.triggers}
        onChange={handleChange}
        width="700px"
      />
      <InputRow
        label="What was your client's explanation for these symptoms?"
        name="triggersExplanation"
        value={form.triggersExplanation}
        onChange={handleChange}
        width="500px"
      />

      <div style={{ marginBottom: "10px", display: "flex", alignItems: "flex-end" }}>
        <label style={{ marginRight: "10px" }}>
          Did the PetCO₂ levels return to baseline levels?
        </label>
        <input
          type="checkbox"
          id="petco2ReturnBaselineYes"
          name="petco2ReturnBaseline"
          checked={form.petco2ReturnBaseline === "yes"}
          onChange={() => handleCheckbox("petco2ReturnBaseline", "yes")}
        />
        <label htmlFor="petco2ReturnBaselineYes" style={{ marginRight: "10px" }}>Yes</label>
        <input
          type="checkbox"
          id="petco2ReturnBaselineNo"
          name="petco2ReturnBaseline"
          checked={form.petco2ReturnBaseline === "no"}
          onChange={() => handleCheckbox("petco2ReturnBaseline", "no")}
        />
        <label htmlFor="petco2ReturnBaselineNo" style={{ marginRight: "10px" }}>No</label>
        <label>How long did it take?</label>
        <input
          type="text"
          name="petco2ReturnTime"
          value={form.petco2ReturnTime}
          onChange={handleChange}
          style={inputStyle("300px")}
        />
      </div>

      <CheckboxRow
        label="Was your client trapped in overbreathing?"
        name="trapped2"
        value={form.trapped2}
        onChange={handleCheckbox}
      />
      <CheckboxRow
        label="If so, did your client recover on his/her own?"
        name="recoverOwn"
        value={form.recoverOwn}
        onChange={handleCheckbox}
      />
      <InputRow
        label="If so, what seemed to be the factor(s) in its return to normal?"
        name="recoverFactors"
        value={form.recoverFactors}
        onChange={handleChange}
        width="500px"
      />
      <InputRow
        label="If not, how did you assist your client in recovery?"
        name="recoverAssistHow"
        value={form.recoverAssistHow}
        onChange={handleChange}
        width="600px"
      />
      <InputRow
        label="What strategies were, and were not, effective?"
        name="strategies"
        value={form.strategies}
        onChange={handleChange}
        width="500px"
      />
      <InputRow
        label="How did the symptoms/deficits change as breathing improved?"
        name="symptomsChangeEnd"
        value={form.symptomsChangeEnd}
        onChange={handleChange}
        width="500px"
      />
      <InputRow
        label="What was the range of PetCO₂ values at the end of interview session?"
        name="petco2EndRange"
        value={form.petco2EndRange}
        onChange={handleChange}
        width="450px"
      />

      <SectionHeader text="EMG (electromyography)" />
      <div style={{ marginBottom: "10px", fontWeight: "bold" }}>
        <label>Placements (1 or 2)</label>
      </div>

      <div style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label>Specific muscle group 1</label>
          <input
            type="text"
            name="muscleGroup1"
            value={form.muscleGroup1}
            onChange={handleChange}
            style={inputStyle("420px")}
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label>Range (mv)</label>
          <input
            type="text"
            name="muscleGroup1Range"
            value={form.muscleGroup1Range}
            onChange={handleChange}
            style={inputStyle("250px")}
          />
        </div>
      </div>

      <div style={{ marginBottom: "10px", display: "flex", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label>Specific muscle group 2</label>
          <input
            type="text"
            name="muscleGroup2"
            value={form.muscleGroup2}
            onChange={handleChange}
            style={inputStyle("420px")}
          />
        </div>
        <div style={{ display: "flex", alignItems: "flex-end" }}>
          <label>Range (mv)</label>
          <input
            type="text"
            name="muscleGroup2Range"
            value={form.muscleGroup2Range}
            onChange={handleChange}
            style={inputStyle("240px")}
          />
        </div>
      </div>

      <div style={{ marginBottom: "10px", marginTop: "20px" }}>
        <strong style={{ marginRight: "10px" }}>
          Was your client "chest breathing" at the start of the session?
        </strong>
        <input
          type="checkbox"
          id="chestBreathingYes"
          name="chestBreathing"
          checked={form.chestBreathing === "yes"}
          onChange={() => handleCheckbox("chestBreathing", "yes")}
        />
        <label htmlFor="chestBreathingYes" style={{ marginRight: "10px" }}>Yes</label>
        <input
          type="checkbox"
          id="chestBreathingNo"
          name="chestBreathing"
          checked={form.chestBreathing === "no"}
          onChange={() => handleCheckbox("chestBreathing", "no")}
        />
        <label htmlFor="chestBreathingNo">No</label>
      </div>

      <InputRow
        label="If so, what breathing accessory muscles were being used?"
        name="accessoryMuscles"
        value={form.accessoryMuscles}
        onChange={handleChange}
        width="330px"
      />
      <InputRow
        label="What seemed to be the triggers for chest breathing?"
        name="chestBreathingTriggers"
        value={form.chestBreathingTriggers}
        onChange={handleChange}
        width="330px"
      />
      <InputRow
        label="What was your client's explanation for chest breathing?"
        name="chestBreathingExplanation"
        value={form.chestBreathingExplanation}
        onChange={handleChange}
        width="330px"
      />
      <InputRow
        label="Did your client like chest breathing? If so, why?"
        name="chestBreathingLike"
        value={form.chestBreathingLike}
        onChange={handleChange}
        width="330px"
      />

      <div style={{ display: "flex", alignItems: "flex-end", margin: "10px 0" }}>
        <label style={{ marginRight: "10px" }}>
          If you asked them to breathe with the diaphragm, could they do it?
        </label>
        <input
          type="checkbox"
          id="diaphragmYes"
          name="diaphragm"
          checked={form.diaphragm === "yes"}
          onChange={() => handleCheckbox("diaphragm", "yes")}
        />
        <label htmlFor="diaphragmYes" style={{ marginRight: "10px" }}>Yes</label>
        <input
          type="checkbox"
          id="diaphragmNo"
          name="diaphragm"
          checked={form.diaphragm === "no"}
          onChange={() => handleCheckbox("diaphragm", "no")}
        />
        <label htmlFor="diaphragmNo" style={{ marginRight: "10px" }}>No</label>
        <input
          type="checkbox"
          id="diaphragmNA"
          name="diaphragm"
          checked={form.diaphragm === "na"}
          onChange={() => handleCheckbox("diaphragm", "na")}
        />
        <label htmlFor="diaphragmNA">N/A</label>
      </div>

      <div style={{ display: "flex", alignItems: "flex-end", margin: "10px 0" }}>
        <label style={{ marginRight: "10px" }}>
          If so, which did they prefer
        </label>
        <input
          type="checkbox"
          id="preferChest"
          name="preferChest"
          checked={form.preferChest}
          onChange={handleChange}
        />
        <label htmlFor="preferChest" style={{ marginRight: "10px" }}>chest</label>
        <input
          type="checkbox"
          id="preferDiaphragm"
          name="preferDiaphragm"
          checked={form.preferDiaphragm}
          onChange={handleChange}
        />
        <label htmlFor="preferDiaphragm" style={{ marginRight: "10px" }}>diaphragm?</label>
        <label style={{ marginRight: "5px" }}>
          What was the preference based on?
        </label>
        <input
          type="text"
          name="preferenceReason"
          value={form.preferenceReason}
          onChange={handleChange}
          style={inputStyle("310px")}
        />
      </div>

      <CheckboxRow
        label="Do you suspect dysponesis?"
        name="dysponesis"
        value={form.dysponesis}
        onChange={handleCheckbox}
      />
      <InputRow
        label="If so, what muscles unrelated to breathing were triggered (e.g., jaw)?"
        name="unrelatedMuscles"
        value={form.unrelatedMuscles}
        onChange={handleChange}
        width="310px"
      />
      <InputRow
        label="What seem to be the triggers for contraction of these muscles?"
        name="unrelatedTriggers"
        value={form.unrelatedTriggers}
        onChange={handleChange}
        width="310px"
      />
      <InputRow
        label="How was dysponesis affected when (and if) your client shifted into the diaphragm?"
        name="dysponesisChange"
        value={form.dysponesisChange}
        onChange={handleChange}
        width="310px"
      />

      <div style={{ marginBottom: "10px", display: "flex", alignItems: "flex-end" }}>
        <label style={{ marginRight: "10px" }}>
          Did posture influence breathing?
        </label>
        <input
          type="checkbox"
          id="postureYes"
          name="posture"
          checked={form.posture === "yes"}
          onChange={() => handleCheckbox("posture", "yes")}
        />
        <label htmlFor="postureYes" style={{ marginRight: "10px" }}>Yes</label>
        <input
          type="checkbox"
          id="postureNo"
          name="posture"
          checked={form.posture === "no"}
          onChange={() => handleCheckbox("posture", "no")}
        />
        <label htmlFor="postureNo" style={{ marginRight: "10px" }}>No</label>
        <label style={{ marginRight: "5px" }}>If so, how?</label>
        <input
          type="text"
          name="postureHow"
          value={form.postureHow}
          onChange={handleChange}
          style={inputStyle("310px")}
        />
      </div>
      <InputRow
        label="How did emotions and thoughts influence shift muscle utilization?"
        name="emotionInfluence"
        value={form.emotionInfluence}
        onChange={handleChange}
        width="310px"
      />
      <InputRow
        label="What correlation did you observe among EMG, PetCO₂, and breathing rate?"
        name="correlation"
        value={form.correlation}
        onChange={handleChange}
        width="310px"
      />

      <SectionHeader text="Other measurements (autonomic and oximetry)" />

      <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ marginRight: "5px" }}>Initial HRV</label>
          <input
            type="text"
            name="initialHRV"
            value={form.initialHRV}
            onChange={handleChange}
            style={inputStyle("120px")}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ marginRight: "5px", marginLeft: "10px" }}>
            HRV range during the session
          </label>
          <input
            type="text"
            name="sessionHRV"
            value={form.sessionHRV}
            onChange={handleChange}
            style={inputStyle("120px")}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ marginRight: "5px", marginLeft: "10px" }}>
            Ending HRV
          </label>
          <input
            type="text"
            name="endingHRV"
            value={form.endingHRV}
            onChange={handleChange}
            style={inputStyle("120px")}
          />
        </div>
      </div>
      <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ marginRight: "5px" }}>Initial SpO₂</label>
          <input
            type="text"
            name="initialSpO2"
            value={form.initialSpO2}
            onChange={handleChange}
            style={inputStyle("120px")}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ marginRight: "5px", marginLeft: "10px" }}>
            SpO₂ range during the session
          </label>
          <input
            type="text"
            name="sessionSpO2"
            value={form.sessionSpO2}
            onChange={handleChange}
            style={inputStyle("120px")}
          />
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <label style={{ marginRight: "5px", marginLeft: "10px" }}>
            Ending SpO₂
          </label>
          <input
            type="text"
            name="endingSpO2"
            value={form.endingSpO2}
            onChange={handleChange}
            style={inputStyle("120px")}
          />
        </div>
      </div>
      <div style={{ marginBottom: "10px", marginTop: "10px" }}>
        <label>
          Were there any correlations between PetCO₂, Breathing Rate, EMG, HRV, & SpO₂? If so, why do you think so?
        </label>
        <textarea
          name="overallCorrelation"
          value={form.overallCorrelation}
          onChange={handleChange}
          style={{
            width: "100%",
            padding: "5px",
            border: "1px solid #ccc",
            marginTop: "5px",
            minHeight: "60px",
            backgroundColor: "#f1f4ff",
            outline: "none",
            height: "100px",
          }}
        ></textarea>
      </div>
         {!data && (
        <div className="client-submit-btn">
          <button type="button" onClick={handleSubmit}>
            {loading ? t("Submitting...") : t("Submit")}
          </button>
        </div>
      )}
       <Modal
              isOpen={successModal}
              toggle={successToggleModal}
              className="connect-box"
              centered={true}
            >
              <ModalHeader toggle={successToggleModal}>
                <span className="ml-1 roititle font-weight-bold">Successfull</span>
              </ModalHeader>
              <ModalBody>
                <div className="modal-p">
                  <p>Trainer form has been submitted successfully.</p>
                </div>
              </ModalBody>
            </Modal>
    </form>
  );
};

function inputStyle(width = "300px", reduceMargin = false, marginRight = "") {
  return {
    width,
    padding: "2px 5px",
    border: "1px solid #ccc",
    marginTop: "5px",
    marginRight: marginRight || (reduceMargin ? "10px" : ""),
    backgroundColor: "#f1f4ff",
    borderBottom: "2px solid #444",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    outline: "none",
  };
}

// For plain label + input
function InputRow({ label, name, value, onChange, width }) {
  return (
    <div style={{ marginBottom: "10px", display: "flex", alignItems: "flex-end" }}>
      <label style={{ marginRight: "10px" }}>{label}</label>
      <input
        type="text"
        name={name}
        value={value}
        onChange={onChange}
        style={inputStyle(width)}
      />
    </div>
  );
}

// For radio button choices like Yes/No
function CheckboxRow({ label, name, value, onChange }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <label style={{ marginRight: "10px" }}>{label}</label>
      <input
        type="checkbox"
        id={`${name}Yes`}
        name={name}
        checked={value === "yes"}
        onChange={() => onChange(name, "yes")}
      />
      <label htmlFor={`${name}Yes`} style={{ marginRight: "10px" }}>Yes</label>
      <input
        type="checkbox"
        id={`${name}No`}
        name={name}
        checked={value === "no"}
        onChange={() => onChange(name, "no")}
      />
      <label htmlFor={`${name}No`}>No</label>
    </div>
  );
}

function SectionHeader({ text }) {
  return (
    <h3
      style={{
        color: "#0066cc",
        marginTop: "20px",
        marginBottom: "10px",
        fontSize: "16px",
      }}
    >
      {text}
    </h3>
  );
}

export default PhysiologyReport;
